// Sugerencias de servicios según el rubro del negocio.
//
// El paso 2 del asistente es donde más gente abandona: la pantalla pide
// "nombre, duración y precio" de algo que todavía no pensó. Un peluquero sabe
// perfectamente qué hace, pero escribirlo de cero, con duraciones y precios,
// frente a un formulario vacío, es trabajo.
//
// Estas sugerencias se agregan con un toque y después se editan. Las
// duraciones son las típicas del rubro; los precios quedan en cero a
// propósito, porque ese número no se puede adivinar y ponerle uno inventado
// es peor que dejarlo vacío.
const S = (nombre, duracion_minutos) => ({ nombre, duracion_minutos, precio_centavos: 0 });

export const SUGERENCIAS = {
  barberia: [S('Corte', 30), S('Barba', 20), S('Corte + barba', 45), S('Corte de niño', 30)],
  peluqueria: [S('Corte', 45), S('Lavado y peinado', 30), S('Color', 90), S('Brushing', 40)],
  estetica: [S('Perfilado de cejas', 20), S('Limpieza de cutis', 60), S('Depilación', 45)],
  unas: [S('Semipermanente', 60), S('Kapping', 90), S('Esculpidas', 120), S('Retiro', 30)],
  tatuajes: [S('Consulta y diseño', 30), S('Sesión chica', 60), S('Sesión larga', 180)],
  masajes: [S('Masaje descontracturante', 60), S('Masaje relajante', 60), S('Drenaje linfático', 75)],
  consultorio: [S('Consulta', 30), S('Control', 20), S('Primera consulta', 45)],
  veterinaria: [S('Consulta', 30), S('Vacunación', 20), S('Baño y corte', 90)],

  // Los clubes no venden servicios distintos: venden tiempo de cancha. Las
  // dos duraciones que de verdad se usan son 60 y 90, y conviene que estén
  // las dos cargadas de entrada porque el precio cambia entre ellas.
  padel: [S('Turno de 60 minutos', 60), S('Turno de 90 minutos', 90), S('Turno de 120 minutos', 120)],
  futbol: [S('Turno de 60 minutos', 60), S('Turno de 90 minutos', 90)],
  tenis: [S('Turno de 60 minutos', 60), S('Turno de 90 minutos', 90)],
  otro_deporte: [S('Turno de 60 minutos', 60), S('Turno de 90 minutos', 90)],

  otro: [S('Consulta', 30), S('Sesión', 60)]
};

export const NOMBRE_DE_RUBRO = {
  barberia: 'Barbería',
  peluqueria: 'Peluquería',
  estetica: 'Estética',
  unas: 'Uñas',
  tatuajes: 'Tatuajes',
  masajes: 'Masajes',
  consultorio: 'Consultorio',
  veterinaria: 'Veterinaria',
  padel: 'Pádel',
  futbol: 'Fútbol',
  tenis: 'Tenis',
  otro_deporte: 'Otro deporte o cancha',
  otro: 'Otro'
};

export const sugerenciasDe = (rubro) => SUGERENCIAS[rubro] ?? SUGERENCIAS.otro;

// Los colores que se ofrecen para distinguir a cada profesional en la agenda.
// Elegidos para que se separen bien entre ellos sobre fondo oscuro.
export const COLORES = [
  '#25D366', '#5B8DEF', '#F59E0B', '#F87171',
  '#A78BFA', '#22D3EE', '#FB923C', '#F472B6'
];
